<template>
<div class="localConfiguration">
  <el-card class="box-card" shadow="never">
    <el-button icon="el-icon-back" style="float: left;" type="primary" @click="goBack()">返回项目列表</el-button>
      <el-steps :active="active" align-center process-status="finish" finish-status="wait">
        <el-step title="用户配置" @click.native="setActive(0)"></el-step>
        <el-step title="遥调遥控配置" @click.native="setActive(1)"></el-step>
      </el-steps>
    <LocalUserConfiguration v-if="active == 0" :projectId="groupId" :projectName="groupName"></LocalUserConfiguration>
    <LocalRemoteControlConfiguration v-if="active == 1" :projectId="groupId" :projectName="groupName"></LocalRemoteControlConfiguration>
  </el-card>
</div>
</template>

<script>
import LocalUserConfiguration from './localUserConfiguration';
import LocalRemoteControlConfiguration from './localRemoteControlConfiguration';

export default {
  props: {
    projectId: {
      type: [String, Number]
    },
    projectName: {
      type: [String, Number]
    }
  },
  components: {
    LocalUserConfiguration,
    LocalRemoteControlConfiguration
  },
  data() {
    return {
      active: 0,
      groupId: '',
      groupName: ''
    };
  },
  computed: {},
  created() {
    this.groupId = this.projectId;
    this.groupName = this.projectName;
  },
  methods: {
    goBack() {
      this.$emit("goBack", false);
    },
    setActive(v) {
      this.active = v;
      if (v == -1) {
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.localConfiguration {
  .box-card {
    .btn {
      padding: 0px;
      font-size: 12px !important;

      &span {
        font-size: 12px !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/boss/project/localConfiguration.vue